import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./vuex"
import ElementUI from 'element-ui';
import '@/assets/bootstrap-5.0.0-beta1-dist/css/bootstrap.min.css'
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/scss/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import globalPlugin from "./utils/global"
import VueCookies from 'vue-cookies'
import VueSession from 'vue-session'
import GSignInButton from 'vue-google-signin-button'

console.log(VueCookies)
Vue.use(GSignInButton);
Vue.use(ElementUI, { locale });
Vue.use(globalPlugin);
Vue.use(VueCookies);
Vue.use(VueSession);

Vue.config.productionTip = false

history.pushState(null, null, document.URL);
window.addEventListener('popstate', function () {
    history.pushState(null, null, document.URL);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
